import React from "react";
import {Link} from "react-router-dom";
import ReactTable from "react-table";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import {isEqual} from "lodash";
import {confirmAlert} from "react-confirm-alert";

const loadedState = {
	Loading: 1,
	ReadyToLoad: 2,
	Loaded: 3,
}


export default class ProductsPending extends CollectionOverride {
	constructor(props) {

		let model = new API.BuildClass(Types.Products._name, API.RequestType.READ_ALL);

		super(props, model);
		this.state.caliber = '';
		this.state.caliber_error = '';
		this.state.calibers = null;
		this.state.manufacturer = '';
		this.state.manufacturer_error = '';
		this.state.manufacturers = null;
		this.state.type = '';
		this.state.type_error = '';
		this.state.types = null;
		this.request = 'GET_PENDINGS';
		this.state.filter = {
		 	"status" : 8
		};

		this.deleteAll = this.deleteAll.bind(this);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		let changed = this.reloadIDs(prevProps, 'collection');
		if (changed) {
			this.loaded = loadedState.Loading;
			this.model.sort = this.sort ? this.sort : "pkey";
			this.model.order = this.order ? this.order : 'desc';
			this.setState({
				filter: {
					"status" : 8
				},
				search: '',
				searchField: '',
				startDate: '',
				endDate: '',
				limit: this.limit || 20,
				filterLocation: null,
				filterStatus: null
			}, this.setPresetsFromLocalStorage);
			return;
		}

		if (prevProps.saveSelf !== this.props.saveSelf) {
			this.afterSubmit().then();
		}

		if (prevProps.reloadSelf !== this.props.reloadSelf) {
			this.reloadTable();
		}

		if (this.loaded === loadedState.Loaded) {
			if (prevState.search !== this.state.search) {
				if (!this.state.search.startsWith('=') || (this.state.search.startsWith('=') && this.state.search.endsWith(';'))) {
					if (this.timeout) clearTimeout(this.timeout);
					this.timeout = setTimeout(() => {
						//search function
						this.reloadTable();
					}, 1000);
				}
			}
			if (prevState.searchField !== this.state.searchField) {
				this.reloadTable();
			}
			if (prevState.filter !== this.state.filter) {
				this.reloadTable();
			}
		}

		const {locations} = this.props;
		if (!isEqual(locations, prevProps.locations)) {
			this.setState({
				unarchivedLocations: this.filterArchivedLocations()
			});
		}

		if ((this.props.scannedCode === null && this.state.searched !== null) || (this.props.scannedCode && this.state.searched !== this.props.scannedCode.barcode)) {
			this.setState({
				search: this.props.scannedCode ? this.props.scannedCode.barcode : this.state.search,
				searched: this.props.scannedCode ? this.props.scannedCode.barcode : null,
			});
		}

		//		this.doFilter({'value': 8}, {'name': 'status'});
	}

	handleSelectPropertyUpdate = (property, value, linked, object) => {
		let updatedState;
		if (linked) {
			if (object && object.hasOwnProperty('binary_id')) {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			} else {
				updatedState = {
					[linked]: object,
					[property]: value,
				};
			}
		} else {
			updatedState = {
				[property]: value,
			};
		}
		this.setState(updatedState);
		this.doFilter({'value': value}, {'name': property});
	};

	clearFilters = () => {
		this.setState({
			key: Math.random(),
			filter: {
				"status" : 8
			},
			search: '',
			startDate: '',
			endDate: '',
			filterLocation: null,
			caliber: '',
			calibers: null,
			manufacturer: '',
			manufacturers: null,
			type: '',
			types: null,
		});
		let path = window.location.pathname.replaceAll('/', ' ').titleCase().replaceAll(' ', '');
		localStorage.removeItem('table-preferences-' + path);
	}

	async deleteAll() {
		confirmAlert({
			title: 'Confirm Delete',
			message: 'Are you sure you want to delete all pending products?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true});
						let teModel = new API.BuildClass(Types.Products._name, API.RequestType.READ);
						try {
							await teModel.submit(null, 'DELETE_PENDING');
						} catch (e) {

						}
						this.setState({loading: false});
						this.props.reloadPage();
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});

	}

	render() {
		const {data, pages, limit, loading,columnsAnchor} = this.state;
		const extraColumns = [
			{
				Header: 'Cost',
				id:"cost",
				accessor:obj => (obj.cost ),
				show: !!this.state['column_price_cost'],
				toggle: 'column_price_cost'
			},
			{
				Header: 'Sale Price',
				id:"price_sale",
				accessor:obj => (obj.price_sale ),
				show: !!this.state['column_price_sale'],
				toggle: 'column_price_sale'
			},
			{
				Header: 'Min Price',
				id:"price_min",
				accessor:obj => (obj.price_min ),
				show: !!this.state['column_price_min'],
				toggle: 'column_price_min'
			},
			{
				Header: 'List Price',
				id:"price_list",
				accessor:obj => (obj.price_list ),
				show: !!this.state['column_price_list'],
				toggle: 'column_price_list'
			},
		];
		const columns = [
			{
				Header: "ID",
				id: "pkey",
				accessor: obj => (obj.id ? obj.id : (obj.binary_id + '-' + obj.pkey))
			},
			{
				Header: "SKU",
				accessor: "sku",
			},
			{
				Header: "Type",
				accessor: "type",
			},
			{
				Header: "Model",
				accessor: "model",
			},
			{
				Header: "Serial",
				accessor: "serial_number",
			},
			{
				Header: "Manufacturer",
				id: 'manufacturer',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
			},
			{
				Header: "Caliber",
				id: 'caliber',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
			},
			...extraColumns,
			{
				Header: "Status",
				id: 'status',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.status ? obj.product_statuses.name : "")
			},
			{
				Header: "Location",
				id: 'location',
				/** @param {Products_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "")
			},
			{
				Header: "Acq. Date",
				id: "acquisition_date",
				width: 160,
				/** @param {Products_Object} obj */
				accessor: obj => {
					return obj.acquisition_date ? moment(obj.acquisition_date)
						.local()
						.format("MM/DD/YYYY") : 'Never Acquired'
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/></Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/${props.original._id}#history`}>
								<Button color="default" size={"sm"} block={true}>
									<i className={"fa fa-file-text-o"}/></Button>
							</Link>
						</span>
					);
				}
			},
		];
		/** @type {Products_Properties} properties */
		let properties = this.model.properties;
		/** @type {Products_Object} object */
		let object = this.state;
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Products', "")}
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="caliber"
										property={properties.caliber}
										value={object.caliber}
										error={object.caliber_error}
										object={object.calibers}
										nullable={true}
									/>
								</div>
								<div className={"statusFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="manufacturer"
										property={properties.manufacturer}
										value={object.manufacturer}
										error={object.manufacturer_error}
										object={object.manufacturers}
										nullable={true}
									/>
								</div>
								<div className={"typeFilter"}>
									<Framework.Elements.Select
										shouldLoad={true}
										update={this.handleSelectPropertyUpdate}
										name="type"
										property={properties.type}
										value={object.type}
										error={object.type_error}
										model={Types.Products_Types._name}
										id={'name'}
										nullable={true}
									/>
								</div>
								{this.renderHeaderRight("Products", columns, extraColumns, columnsAnchor, this.handleOpen, this.handleClose,
									<button id="all" onClick={this.deleteAll} className="btn btn-default" style={{whiteSpace: 'nowrap'}}>
										Delete All
									</button>
								)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSizeOptions={[5, 10, 20, 25, 50, 100, 500, 1000, 'All']}
							renderPageSizeOptions={this.renderPageSizes}
							pageSize={limit}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
